import { spApi } from './sp';

export const getBusinessOwnerViewApi = spApi.injectEndpoints({
  endpoints: (builder) => ({
    getBusinessOwnerView: builder.query({
      providesTags: (result, error, businessId) => [{ type: 'businessDetails', id: businessId }],
      query: (businessId) => `/business/${businessId}/ownerview`,
    }),
  }),
  overrideExisting: false,
});

export const { useGetBusinessOwnerViewQuery } = getBusinessOwnerViewApi;